import { render, staticRenderFns } from "./ActionsPopover.vue?vue&type=template&id=0735fdb9"
import script from "./ActionsPopover.vue?vue&type=script&lang=js"
export * from "./ActionsPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports